export default __webpack_public_path__ + "static/media/ph_tiktok-logo.c7f03d38.svg";